export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1718_.bed84779.jpg";